// Central store
import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/user";
import companyReducer from "./slices/company";
import interviewReducer from "./slices/interview";
import statuses from "./slices/statuses";
import tags from "./slices/tags";
import jobs from "./slices/jobs";
import payments from "./slices/payments";

const store = configureStore({
  reducer: {
    user: userReducer,
    company: companyReducer,
    interview: interviewReducer,
    statuses:statuses,
    tags:tags,
    jobs,
    payments,
  },
  // thunk is on by default; devTools auto-enabled in development
});

export default store;
